import React from 'react';
/* A function that returns a JSX element. */
export const IconoNotificaciones = (props) => {
	/* Destructuring the props object. */
	const {numMensajes, goToNotificaciones} = props;
	/* A function that returns a JSX element. */
	return (
		<div
			className='iconCarrito'
			onClick={goToNotificaciones}
		>
			<div className=''>
				<svg
					xmlns='http://www.w3.org/2000/svg'
					width='23'
					height='23'
					fill='currentColor'
					className='bi bi-bell'
					viewBox='0 0 16 16'
				>
					<path d='M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2zM8 1.918l-.797.161A4.002 4.002 0 0 0 4 6c0 .628-.134 2.197-.459 3.742-.16.767-.376 1.566-.663 2.258h10.244c-.287-.692-.502-1.49-.663-2.258C12.134 8.197 12 6.628 12 6a4.002 4.002 0 0 0-3.203-3.92L8 1.917zM14.22 12c.223.447.481.801.78 1H1c.299-.199.557-.553.78-1C2.68 10.2 3 6.88 3 6c0-2.42 1.72-4.44 4.005-4.901a1 1 0 1 1 1.99 0A5.002 5.002 0 0 1 13 6c0 .88.32 4.2 1.22 6z' />
				</svg>
			</div>
			{numMensajes >= 1 && (
				<div className='alertIconHeader'>
					<svg
						xmlns='http://www.w3.org/2000/svg'
						width='17'
						height='17'
						fill='currentColor'
						className='bi bi-exclamation-circle-fill'
						viewBox='0 0 16 16'
					>
						<path d='M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4zm.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2z' />
					</svg>
				</div>
			)}
		</div>
	);
};
